import { useEffect, useMemo } from 'react';
import { Col } from 'antd';
import { ControlType } from '../../../DynamicComponent/config';
import { isArray } from '@lhb/func';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';

/**
 * @description 预测营业额
 */
const EstimateSalesOfYht = ({
  propertyItems,
  form,
}) => {
  // 美团竞品均值组件
  const mtMeanCom = useMemo(() => {
    const target = propertyItems.find((item) => item.controlType === ControlType.ESTIMATE_SALES_MT_MEAN_YHT.value);
    return target || {};
  }, [propertyItems]);
  // 美团竞品高值组件
  const mtMaxCom = useMemo(() => {
    const target = propertyItems.find((item) => item.controlType === ControlType.ESTIMATE_SALES_MT_MAX_YHT.value);
    return target || {};
  }, [propertyItems]);

  // 初始化赋值
  useEffect(() => {
    if (!(isArray(propertyItems) && propertyItems.length)) return;
    form.setFieldsValue({
      [mtMeanCom?.identification || 'mean']: mtMeanCom?.textValue || '',
      [mtMaxCom?.identification || 'max']: mtMaxCom?.textValue || '',
    });
  }, [mtMeanCom, mtMaxCom]);

  return <>
    <Col span={24}>
      <V2FormInputNumber
        label={mtMeanCom?.anotherName || mtMeanCom?.name}
        name={mtMeanCom?.identification}
        placeholder='输入内容'
        max={999999999}
        required
        config={{
          addonAfter: '元'
        }}
      />
    </Col>
    <Col span={24}>
      <V2FormInputNumber
        label={mtMaxCom?.anotherName || mtMaxCom?.name}
        name={mtMaxCom?.identification}
        placeholder='输入内容'
        max={999999999}
        required
        config={{
          addonAfter: '元'
        }}
      />
    </Col>
  </>;
};
export default EstimateSalesOfYht;
